import { render } from "./Organisation.Businesses.Modify.vue?vue&type=template&id=1ece7aa6"
import script from "./Organisation.Businesses.Modify.vue?vue&type=script&lang=js"
export * from "./Organisation.Businesses.Modify.vue?vue&type=script&lang=js"

import "./Organisation.Businesses.Modify.vue?vue&type=style&index=0&id=1ece7aa6&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__